export default __webpack_public_path__ + "static/rocketlink-c732074ec868539b96735cd32abbfbea.png";